import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { FuseAlertComponent } from '@fuse/components/alert';
import { ISnackbarMsgConfig } from './snackbar-msg.interface';

@Component({
    selector: 'app-snackbar-msg',
    standalone: true,
    imports: [
        MatSnackBarModule,
        FuseAlertComponent
    ],
    template: `
        <fuse-alert [type]="config.type" [appearance]="config.appearance">
            <span fuseAlertTitle>{{config.title}}</span>
            {{config.message}}
        </fuse-alert>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarMsgComponent { 
    snackbarMsg = inject(MatSnackBarRef)

    config = this.data;

	constructor(
		@Inject(MAT_SNACK_BAR_DATA) public data: ISnackbarMsgConfig
	) { }
}
